<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Supporting Digital Business Transformation
                                    
                                </h1>
                                
                                <p class="lead  text-white">We orchestrate an inventive mindset and a structured approach for the maximum benefit of our customers.</p>
                            
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="dark" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Software Development</h6>

                                    <p class="description mt-3">Customized Software Solution for Your Business.</p>
                                   
                                    <base-button tag="a" href="/software-services" type="dark" class="mt-4">
                                        Explore
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-istanbul" type="dark" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase">Technology Consulting</h6>

                                    <p class="description mt-3">Solve critical business challenges by leveraging right technology.</p>
                                    
                                    <base-button tag="a" href="/technology-consulting" type="dark" class="mt-4">
                                        Explore
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-planet" type="dark" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">Cloud Migration</h6>
                                    <p class="description mt-3">Start your cloud migration strategy with trusted cloud consulting services from SMAKINTEL.</p>
                                   
                                    <base-button tag="a" href="#" type="dark" class="mt-4">
                                        Explore
                                    </base-button>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       
        <section class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-4">
                        <div class="card bg-dark shadow border-0">
                            <img v-lazy="'img/theme/why-work-with-smakintel.jpg'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">Software Development</h4>
                                <p class="lead text-italic text-white">The development of reliable and scalable software solutions for any OS, browser and device.</p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-8">

                           
                        <div class="row text-center justify-content-center">
                            <div class="col-lg-10">
                                <h2 class="display-3 text-dark">Distinct phases to help manage your projects.</h2>
                                
                            </div>
                        </div>
                        <div class="row row-grid mt-5">
                            <ul>
                                <li>Planning : Planning is a crucial step to begin it. If the plan is charted out half the battle is won.</li>
                                <li>Analysis : Analysing the performances of the software during different stages of its development will ensure that the software is being developed as per the requirement. Also, if additional requirements come up, it can be implemented without disturbing the entire process.</li>
                                <li>Design : After analysis designing takes over. It is basically building the architectural structure of the project.</li>
                            </ul>

                         
                        </div>

                         <div class="row row-grid mt-5">
                            <div class="col-lg-4">
                                <icon name="ni ni-settings" size="lg" gradient="white" shadow round color="primary"></icon>
                                <h5 class="text-dark mt-3">Development & Implementation</h5>
                                <p class="text-dark mt-3">Software development process actually starts with this step. And as the product is developed, the product goes through a pilot study to check whether the product is functioning properly or not.</p>
                            </div>
                            <div class="col-lg-4">
                                <icon name="ni ni-ruler-pencil" size="lg" gradient="white" shadow round color="primary"></icon>
                                <h5 class="text-dark mt-3">Testing</h5>
                                <p class="text-dark mt-3"> The testing stage makes an assessment of the software product and checks for any errors and bugs..</p>
                            </div>
                            <div class="col-lg-4">
                                <icon name="ni ni-atom" size="lg" gradient="white" shadow round color="primary"></icon>
                                <h5 class="text-dark mt-3">Maintenance & Support</h5>
                                <p class="text-dark mt-3">Once the product clears the testing stage and is found without any issues, it is passed on to the maintenance process. </p>
                            </div>
                        </div>
                    
                                        
                    </div>
                </div>
            </div>
        </section>
        
        
        <section class="section section-lg pt-0">
            <div class="container">
                <card gradient="dark"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">Engage SMAKINTEL.</h3>
                                <p class="lead text-white mt-3">Looking for an experienced software development team.</p>
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="/contact-us"
                                             type="white" block size="lg">
                                    Contact Us
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>

             

    </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>
